import { Loader } from "@launchmetrics/lm-ui";
import 'components/LM/InstagramSearch/InstagramSearch.scss';
import Breadcrumb from "components/LM/common/Breadcrumb";
import K2Api from 'lib/ajax/K2Api';
import { useState } from "react";
import { Button, ButtonToolbar, Card, Form } from "react-bootstrap";
import { useHistory } from "react-router-dom";

function InstagramSearch({ location }) {
  const history = useHistory();
  const [processing, setProcessing] = useState(false);

  let query = location.state;

  const onInputChange = (query) => {
    history.replace(window.location.pathname, query);
  }

  const k2Api = new K2Api();
  const onSubmit = async (ev) => {
    ev.preventDefault();
    const terms = query.split("\n");
    const termsTrimmed = terms.filter(function (el) {
      return el !== "";
    });
    if (!termsTrimmed.length) return;

    setProcessing(true)

    const response = await k2Api.post(
      '/socialmedia/instagram/search/url',
      { urls: termsTrimmed }
    );
    history.replace(window.location.pathname, query);
    history.push(window.location.pathname + '/results', { results: response.data });
  };

  return (
    <div className="instagram-search-form">
      <Form>
        <Breadcrumb items={['Instagram Search']} />
        <Card>
          <Card.Header>
            <Card.Title tag="h5">Enter a list of instagram URLS here, one profile per line:</Card.Title>
            <h6 className="text-muted info">You can enter up top 100 instagram profiles.</h6>
            <h6 className="text-muted">After submitting the data, the profiles will be searched in Instagram API & in our Database</h6>
          </Card.Header>
          <Card.Body>
            <Form.Group className="mb-3" controlId="inSearchProfiles">
              <Form.Control as="textarea" rows="10" onChange={(ev) => { onInputChange(ev.target.value) }} value={(query == null) ? '' : query} />
            </Form.Group>
            <ButtonToolbar>
              <Button
                color="info"
                type="submit"
                className="mr-1 mb-1"
                onClick={(ev) => { onSubmit(ev) }}
                disabled={processing || !query || !query.length}
              >
                Submit
                {processing && <Loader styleProps={{ marginLeft: '10px'}}size={20} />}
              </Button>
            </ButtonToolbar>
          </Card.Body>
        </Card>
      </Form>
    </div >
  );
}

export default InstagramSearch;
